// extracted by mini-css-extract-plugin
export default {"icon":"UserAvatar_icon__KfmMc"};